import React from 'react';
import { IStep, PageContents } from './StrategyExercisePlan';
import { STEPS } from 'models/exercises/IExercisePlan';

export const StepSixPage: React.FC<IStep> = ({ content, setStep }) => {
  return (
    <React.Fragment>
      <PageContents content={content} children={undefined} onCtaClick={() => setStep(STEPS.FINAL)}/>
    </React.Fragment>
  )
}